import api from './api'

export const returnsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/returns/admin', { params })
    return res.data
  },

  approve: async (id, refundAmount) => {
    const res = await api.patch(`/returns/admin/${id}/approve`, { refundAmount })
    return res.data.data
  },

  reject: async (id, note) => {
    const res = await api.patch(`/returns/admin/${id}/reject`, { note })
    return res.data.data
  },
}
